export enum FilterName {
  AIRCRAFT = 'Aircraft',
  PORTABLE = 'Portable Device',
  SUBSCRIPTION = 'Subscription Type',
  REGION = 'Region',
  PRODUCT_TYPE = 'Product Type',
  MOBILE_DEVICE = 'Mobile Device'
}
